import { PilotTelemetryStore } from '../stores/PilotTelemetryStore';

export interface TelemetryGeneratorOptions {
  intervalMs?: number;
}

export default class TelemetryGenerator {
  private timer: number | null = null;
  private readonly intervalMs: number;

  constructor(private store: PilotTelemetryStore, options: TelemetryGeneratorOptions = {}) {
    this.intervalMs = options.intervalMs ?? 1000;
  }

  start() {
    if (this.timer) return;
    this.timer = window.setInterval(() => this.step(), this.intervalMs);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  private step() {
    const t = this.store.telemetry;
    const speedMps = t.horizontalSpeed * 0.44704; // mph -> m/s
    const distance = speedMps * (this.intervalMs / 1000);
    const headingRad = (t.heading * Math.PI) / 180;
    const earthRadius = 6378137; // meters

    const dLat = (distance * Math.cos(headingRad)) / earthRadius;
    const dLon = (distance * Math.sin(headingRad)) / (earthRadius * Math.cos((t.lat * Math.PI) / 180));

    const newLat = t.lat + (dLat * 180) / Math.PI;
    const newLon = t.lon + (dLon * 180) / Math.PI;
    const newAlt = t.altitude + t.verticalSpeed * (this.intervalMs / 1000);

    this.store.updateTelemetry({ lat: newLat, lon: newLon, altitude: newAlt });
    this.store.addPathPoint(newLat, newLon);
  }
}
